import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(private readonly platform: Platform) {}

  /** Native only: marks the current bundle as ready (required for OTA rollbacks). */
  async init(): Promise<void> {
    await this.platform.ready();

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await CapacitorUpdater.notifyAppReady();
      console.info('Capgo updater initialized');
    } catch (error: unknown) {
      console.error('Failed to initialize Capgo updater:', error);
    }
  }
}
